import React, { useState } from "react";
import { Activity, ActivityFeed } from "@ofqual/portal-activity-feed";
import { buildDefinitions } from "./buildDefinitions";
import { RenderDialog } from "./RenderDialog";
import { Unit } from "../../../domain/Unit";

type UnitActivityFeedProps = {
  unitItem: Unit;
};

export const UnitActivityFeed: React.FC<UnitActivityFeedProps> = ({
  unitItem,
}) => {
  const [focussedEntity, setFocussedEntity] = useState<Activity | null>(null);

  const definitions = buildDefinitions(unitItem, (activity) => {
    setFocussedEntity(activity);
  });

  return (
    <>
      <ActivityFeed
        resourceId={unitItem.id}
        definitions={definitions}
        actions={[]}
      />
      <RenderDialog
        focussedEntity={focussedEntity}
        onClose={() => setFocussedEntity(null)}
        unitItem={unitItem}
      />
    </>
  );
};
